import { render, staticRenderFns } from "./weaponpool.vue?vue&type=template&id=5f547030"
import script from "./weaponpool.vue?vue&type=script&lang=js"
export * from "./weaponpool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports